import * as React from 'react';
import { compose } from 'redux';
import { FixedSizeList as List } from 'react-window';
import { debounce } from 'throttle-debounce';
import { Set } from 'immutable';
import ResizeObserver from 'react-resize-observer';
import { promisify } from '@/lib/helpers';
import elements from '@/components/elements';
import makeCancelable from '@/lib/makeCancelable';
import CONST from '@/components/Tables/constatnt';
import { getHeight, getLoadPagesByRows, zipQueryParams } from '@/components/Tables/layout/JEVirtualLinesTable/helpers';
import VRow, { Row } from '@/components/Tables/layout/JEVirtualLinesTable/row';
import withResize from '@/components/Tables/layout/JEVirtualLinesTable/withResize';
import withColSwitch from '@/components/Tables/layout/JEVirtualLinesTable/withColSwitch';
import withRowMessages from '@/components/Tables/layout/JEVirtualLinesTable/withRowMessages';
import withGoogleSearch from '@/components/Tables/grid/withGoogleSearch';
import withSelectedRows from '@/components/Tables/grid/withSelectedRows';

import {
  JEVirtualLinesRoot,
  JEVirtualLinesTableBody,
  JEVirtualLinesTableHeader,
  VirtualOuterElement,
} from '@/components/Tables/layout/JEVirtualLinesTable/StyledComponents';

// eslint-disable-next-line react/prop-types
const OuterElement = React.forwardRef(({ children, style: { height }, onScroll }, ref) => {
  const style = { maxHeight: height };
  return (
    <VirtualOuterElement className="scroll-box" style={style} onScroll={onScroll} ref={ref}>
      {children}
    </VirtualOuterElement>
  );
});

class JEVirtualLinesTable extends React.Component {
  componentWillUnmount() {
    if (this.getJECancellable) {
      this.getJECancellable.cancel();
    }
  }

  onRender = ({ visibleStartIndex, visibleStopIndex }) => {
    const visible = [visibleStartIndex, visibleStopIndex];
    this.visible = visible;
    this.props.onRowsRender(visible);
    this.loadPage(visible);
  };

  get itemData() {
    // eslint-disable-next-line max-len
    const { active, meta, lineItems, removeHandler, getItem, selectedRows, reconcileColumn, data } = this.props;

    return {
      meta: [meta[0], meta[1].slice(1)],
      getItem,
      active,
      lineItems,
      removeHandler,
      selectedRows,
      reconcileColumn,
      data,
    };
  }

  getJECancellable;

  loadPage = debounce(50, ([start, end]) => {
    const { loadedPages } = this.props;
    const loadPages = getLoadPagesByRows(start, end, 0);
    const subtract = this.waiting.concat(loadedPages);
    const needPages = loadPages.filter((p) => !subtract.includes(p));
    this.loadJE(needPages);
  });

  loadJE = (pageList) => {
    const { getJournalEntry, loadedPages, onChangeLoadedPages } = this.props;
    if (pageList.length) {
      this.waiting = this.waiting.concat(pageList);
      this.getJECancellable = makeCancelable(promisify(getJournalEntry, zipQueryParams(pageList)));
      this.getJECancellable.promise
        .then(() => {
          this.waiting = this.waiting.filter((p) => !pageList.includes(p));
          onChangeLoadedPages([...loadedPages, ...pageList]);
        })
        .catch(() => null);
    }
  };

  refProxy = (el) => {
    this.container = el;
    this.props.refProxy(el);
  };

  refresh = () => {
    this.forceUpdate();
  };

  visible = [0, 0];

  waiting = new Set();

  container;

  header;

  // eslint-disable-next-line react/no-multi-comp
  innerElementType = React.forwardRef(({ children, ...rest }, ref) => {
    const { meta, data } = this.props;
    const row = meta[1][0];
    const rowEntries = data.filter((f) => f._row === row);
    return (
      <>
        <JEVirtualLinesTableHeader>
          <Row
            meta={meta}
            r={row}
            active={null}
            getItem={this.props.getItem}
            rowEntries={rowEntries}
            reconcileColumn={this.props.reconcileColumn}
          />
        </JEVirtualLinesTableHeader>
        <JEVirtualLinesTableBody {...rest} ref={ref}>
          {children}
        </JEVirtualLinesTableBody>
      </>
    );
  });

  render() {
    const { rtl, lineCount } = this.props;

    return (
      <JEVirtualLinesRoot ref={this.refProxy} data-element={elements.je.virtualGrid.container}>
        <ResizeObserver onResize={() => this.refresh()} />
        {this.container ? (
          <List
            innerElementType={this.innerElementType}
            height={getHeight(this.container)}
            itemSize={CONST.ROW_HEIGHT}
            itemCount={lineCount - 1}
            width="100%"
            itemData={this.itemData}
            onItemsRendered={this.onRender}
            outerElementType={OuterElement}
            direction={rtl ? 'rtl' : 'ltr'}
          >
            {VRow}
          </List>
        ) : null}
      </JEVirtualLinesRoot>
    );
  }
}

export default compose(
  withColSwitch,
  withResize,
  withSelectedRows,
  withRowMessages,
  withGoogleSearch,
)(JEVirtualLinesTable);
